import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isAdminFlow } from './url-utils';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  constructor(
    private titleService: Title,
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateTitle();
    });
  }

  private updateTitle(): void {
    const isStaffPortal = isAdminFlow();
    const title = isStaffPortal ? 'Staff Portal - Agri Labour Australia' : 'Candidate Portal - Agri Labour Australia';
    this.titleService.setTitle(title);
  }
}